import React from "react";

const Header166 = ({ type }) => {
  // Determina el texto dinámico según el parámetro `type`
  let displayText;

  switch (type) {
    case "s":
      displayText = "Proyectos de Sostenibilidad";
      break;
    case "s_vt":
      displayText = "Gestión de visitas técnicas Sostenibilidad";
      break;
    case "poa":
      displayText = "POA - Plan Operativo Anual";
      break;
    case "g":
      displayText = "Gestión de Bodegas";
      break;
    case "p":
      displayText = "Gestión de Productos";
      break;
    case "pl":
      displayText = "Planes de Compras - PAATI";
      break;
    case "ps":
      displayText = "Planes de Compras - SOSTENIBILIDAD";
      break;
    case "poaS":
      displayText = "Plan Operativo Anual  por proyecto - SOSTENIBILIDAD";
      break;
    case "pr":
      displayText = "Gestión de participantes";
      break;
    case "n":
      displayText = "Gestión de novedades";
      break;
    case "vt":
      displayText = "Gestión de visitas técnicas";
      break;
    case "ordens":
      displayText = "Ordenes de Compra";
      break;
    case "proveedoresPO":
      displayText = "Gestión de proveedores";
      break;
    case "entregaspaati":
      displayText = "Gestión de entregas PAATI";
      break;
    case "entregasSostenibilidad":
      displayText = "Gestión de asignaciones SOSTENIBILIDAD";
      break;
    case "salidabodega":
      displayText = "Gestión de entregas SOSTENIBILIDAD";
      break;

    default:
      displayText =
        "PAATI: Personas en proceso de reincorporación cuentan con asistencia técnica integral para los proyectos productivos individuales e individuales asociativos desembolsados proyecto 166";
  }

  return (
    <div className="col-md-7 linea_separador mb-2 d-flex align-items-center">
      <div
        className="titulo_proyecto"
        style={{ flexBasis: "30%", flexGrow: 0 }}
      >
        <p>
          PROYECTO UTF <br /> COL 166 COL
        </p>
      </div>
      <div className="objeto" style={{ flexBasis: "75%", flexGrow: 0 }}>
        <p>{displayText}</p>
      </div>
    </div>
  );
};

export default Header166;
